// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import * as XLSX from "xlsx";

// import {
//   getCustomers,
//   getCustomer,
//   deleteCustomer,
// } from "../../../services/customer.services";

// import {
//   setCustomers,
//   setCustomerDetail,
//   applyFilters,
// } from "../../../state/reducers/customerSlice";
// import { formatDateTime } from "../../../utils/dateFormat";
// import { getNewTable } from "../../../services/mainServices.services";

// // Import icons
// import {
//   Search,
//   Download,
//   FileSpreadsheet,
//   Filter,
//   X,
//   ChevronLeft,
//   ChevronRight,
//   ChevronsLeft,
//   ChevronsRight,
//   Eye,
//   Calendar,
//   UserCheck,
//   MapPin,
//   Flag,
//   GraduationCap,
//   Building,
//   Menu,
//   ChevronDown,
//   ChevronUp,
// } from "lucide-react";

// const CustomerList = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const customers = useSelector((state) => state.customer.customers);
//   const admins = useSelector((state) => state.admin.admins);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [customersPerPage, setCustomersPerPage] = useState(10);
//   const filteredCustomer = useSelector(
//     (state) => state.customer.filteredCustomers
//   );

//   // Local states
//   const [selectedCustomers, setSelectedCustomers] = useState([]);
//   const [coreServices, setCoreServices] = useState([]);
//   const [sortedCustomers, setSortedCustomers] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [showFilters, setShowFilters] = useState(false); // Changed to false for mobile
//   const [isLoading, setIsLoading] = useState(true);
//   const [sortBy, setSortBy] = useState("created_at");
//   const [sortOrder, setSortOrder] = useState("desc");
//   const [viewMode, setViewMode] = useState("table"); // 'table' or 'cards'

//   const [filters, setFilters] = useState({
//     assigned: "",
//     serviceType: "",
//     branch: "",
//     country: "",
//     intendedDegree: "",
//     intake: "",
//     fromDate: "",
//     toDate: "",
//   });

//   // Get unique countries from customer data
//   const uniqueCountry = Array.from(
//     new Set(customers.flatMap((customer) => customer.preferred_countries))
//   );

//   // Filter customers based on all active filters
//   useEffect(() => {
//     if (customers && customers.length > 0) {
//       let result = [...customers];

//       // Apply assigned filter
//       if (filters.assigned) {
//         result = result.filter(
//           (customer) => customer.assigned_to == filters.assigned
//         );
//       }

//       // Apply branch filter
//       if (filters.branch) {
//         result = result.filter((customer) => customer.branch == filters.branch);
//       }

//       // Apply service type filter
//       if (filters.serviceType) {
//         result = result.filter((customer) =>
//           customer.services.some(
//             (service) => service.coreservice_name === filters.serviceType
//           )
//         );
//       }

//       // Apply country filter
//       if (filters.country) {
//         result = result.filter((customer) =>
//           customer.preferred_countries.includes(filters.country)
//         );
//       }

//       // Apply intended degree filter
//       if (filters.intendedDegree) {
//         result = result.filter(
//           (customer) => customer.intended_degree == filters.intendedDegree
//         );
//       }

//       // Apply date range filter
//       if (filters.fromDate && filters.toDate) {
//         const fromDateFilter = new Date(filters.fromDate);
//         const toDateFilter = new Date(filters.toDate);
//         toDateFilter.setDate(toDateFilter.getDate() + 1);

//         result = result.filter((customer) => {
//           const customerDate = new Date(customer.created_at);
//           return customerDate >= fromDateFilter && customerDate <= toDateFilter;
//         });
//       }

//       // Apply intake filter
//       if (filters.intake) {
//         result = result.filter((customer) => {
//           const customerIntakeMonthYear = customer.intake
//             ? customer.intake.slice(0, 7)
//             : "";
//           return customerIntakeMonthYear === filters.intake;
//         });
//       }

//       // Apply sorting
//       result.sort((a, b) => {
//         const aValue = a[sortBy] || "";
//         const bValue = b[sortBy] || "";

//         if (sortOrder === "asc") {
//           return aValue.localeCompare(bValue);
//         } else {
//           return bValue.localeCompare(aValue);
//         }
//       });

//       setSortedCustomers(result);
//     } else {
//       setSortedCustomers([]);
//     }
//   }, [customers, filters, sortBy, sortOrder]);

//   // Fetch all customers on mount
//   const fetchAllCustomers = async () => {
//     setIsLoading(true);
//     try {
//       const response = await getCustomers();
//       dispatch(setCustomers(response.data.data));
//     } catch (err) {
//       console.error("Error fetching all customers:", err);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Fetch core services
//   const fetchCoreServices = async () => {
//     try {
//       const data = await getNewTable();
//       setCoreServices(data);
//     } catch (error) {
//       console.error("Failed to fetch core services:", error);
//     }
//   };

//   // Initial data fetch
//   useEffect(() => {
//     fetchAllCustomers();
//     fetchCoreServices();
//   }, [dispatch]);

//   // Handle row click to view customer details
//   const handleRowClick = async (id) => {
//     try {
//       const response = await getCustomer(id);
//       dispatch(setCustomerDetail(response.data));
//       navigate(`${id}`);
//     } catch (error) {
//       console.error("Failed to fetch customer detail:", error);
//     }
//   };

//   // Handle selection of single checkbox
//   const handleSelect = (id, e) => {
//     e.stopPropagation();
//     setSelectedCustomers((prev) =>
//       prev.includes(id)
//         ? prev.filter((customerId) => customerId !== id)
//         : [...prev, id]
//     );
//   };

//   // Handle "Select All" checkbox
//   const handleSelectAll = (e) => {
//     if (selectedCustomers.length === currentCustomers.length) {
//       setSelectedCustomers([]);
//     } else {
//       setSelectedCustomers(currentCustomers.map((c) => c.id));
//     }
//   };

//   // Export selected customers to Excel
//   const handleExportSelected = () => {
//     if (selectedCustomers.length === 0) {
//       toast.error("No customers selected to export!");
//       return;
//     }

//     const selectedData = customers.filter((c) =>
//       selectedCustomers.includes(c.id)
//     );

//     const formattedData = selectedData.map((customer, index) => ({
//       "S.No": index + 1,
//       Name: customer.name || "-",
//       Email: customer.email || "-",
//       Phone: customer.phone || "-",
//       Address: customer.address || "-",
//       Intake: customer.intake || "-",
//       "Preferred Countries": customer.preferred_countries?.join(", ") || "-",
//       "Service Taken Details":
//         customer.services
//           .map((service) => service.coreservice_name)
//           .join(", ") || "-",
//       Branch: customer.branch || "-",
//       Status: customer.status || "-",
//       "Parents' Email": customer.parents_email || "-",
//       "Alternate Contact Number": customer.alternate_contact_number || "-",
//       "Assigned Content Writer": customer.assigned_content_writer || "-",
//       "Assigned To":
//         admins.find((admin) => admin.admin_id == customer.assigned_to)
//           ?.username || "-",
//     }));

//     const worksheet = XLSX.utils.json_to_sheet(formattedData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Selected Customers");
//     XLSX.writeFile(workbook, "Selected_Customers.xlsx");

//     toast.success("Selected customers exported successfully!");
//   };

//   // Handle filter change
//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//     dispatch(applyFilters({ filters: { ...filters, [name]: value } }));
//   };

//   // Reset all filters
//   const resetFilters = () => {
//     setFilters({
//       assigned: "",
//       serviceType: "",
//       branch: "",
//       country: "",
//       intendedDegree: "",
//       intake: "",
//       fromDate: "",
//       toDate: "",
//     });
//     setSearchQuery("");
//     dispatch(applyFilters({ filters: {} }));
//   };

//   // Generate month-year options for intake filter
//   const generateMonthYearOptions = () => {
//     const options = [];
//     const currentDate = new Date();
//     const currentYear = currentDate.getFullYear();

//     // Generate options for 5 years past and 5 years future
//     for (let year = currentYear - 5; year <= currentYear + 5; year++) {
//       for (let month = 0; month < 12; month++) {
//         const date = new Date(year, month);
//         const formattedDate =
//           date.toLocaleString("default", { month: "short" }) + "-" + year;
//         options.push({
//           value: `${year}-${month + 1 < 10 ? "0" : ""}${month + 1}`,
//           label: formattedDate,
//         });
//       }
//     }

//     return options;
//   };

//   // Filter customers by search query
//   const filteredBySearch = sortedCustomers.filter((customer) =>
//     `${customer.name} ${customer.email}`
//       .toLowerCase()
//       .includes(searchQuery.toLowerCase())
//   );

//   // Pagination
//   const indexOfLastCustomer = currentPage * customersPerPage;
//   const indexOfFirstCustomer = indexOfLastCustomer - customersPerPage;
//   const currentCustomers = filteredBySearch.slice(
//     indexOfFirstCustomer,
//     indexOfLastCustomer
//   );
//   const totalPages = Math.ceil(filteredBySearch.length / customersPerPage);

//   // Change page
//   const paginate = (pageNumber) => {
//     if (pageNumber >= 1 && pageNumber <= totalPages) {
//       setCurrentPage(pageNumber);
//     }
//   };

//   // Format service names for display
//   const formatServices = (services) => {
//     if (!services || services.length === 0) return "-";
//     return services
//       .map((service) => service.coreservice_name)
//       .filter((name) => name)
//       .join(", ");
//   };

//   // Get assigned admin name
//   const getAssignedName = (assignedId) => {
//     const admin = admins.find((admin) => admin.admin_id == assignedId);
//     return admin ? admin.username : "-";
//   };

//   // Toast notification function (simplified version)
//   const toast = {
//     success: (message) => alert(message),
//     error: (message) => alert(message),
//   };

//   // Count active filters
//   const activeFiltersCount = Object.values(filters).filter(
//     (value) => value !== ""
//   ).length;

//   function capitalizeName(name) {
//     return name
//       ?.split(" ")
//       .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
//       .join(" ");
//   }

//   return (
//     <div className="bg-gray-50 min-h-screen">
//       <div className="p-3 sm:p-4 lg:p-6 max-w-full mx-auto">
//         {/* Header */}
//         <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6 mb-4 sm:mb-6">
//           <div className="flex flex-col space-y-4 sm:space-y-0 sm:flex-row sm:justify-between sm:items-start">
//             <div className="flex-1">
//               <h1 className="text-xl sm:text-2xl font-bold text-gray-800">
//                 Students Database
//               </h1>
//               <p className="text-gray-500 mt-1 text-sm sm:text-base">
//                 Manage and view all students in the system
//               </p>
//             </div>

//             <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-3">
//               {/* Search Input */}
//               <div className="relative flex-1 sm:flex-none sm:w-64">
//                 <input
//                   type="text"
//                   placeholder="Search students..."
//                   value={searchQuery}
//                   onChange={(e) => setSearchQuery(e.target.value)}
//                   className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-700 text-sm"
//                 />
//                 <Search
//                   className="absolute left-3 top-2.5 text-gray-400"
//                   size={16}
//                 />
//               </div>

//               {/* Export Button */}
//               <button
//                 onClick={handleExportSelected}
//                 disabled={selectedCustomers.length === 0}
//                 className={`flex items-center justify-center px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
//                   selectedCustomers.length === 0
//                     ? "bg-gray-200 text-gray-500 cursor-not-allowed"
//                     : "bg-green-600 text-white hover:bg-green-700"
//                 }`}
//               >
//                 <FileSpreadsheet size={16} className="mr-2" />
//                 <span className="hidden sm:inline">Export</span>
//                 {selectedCustomers.length > 0 && (
//                   <span className="ml-1">({selectedCustomers.length})</span>
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Filters Section */}
//         <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-4 sm:mb-6">
//           <div className="p-4 border-b border-gray-200">
//             <div className="flex items-center justify-between">
//               <div className="flex items-center">
//                 <Filter className="text-gray-500 mr-2" size={18} />
//                 <h2 className="text-base sm:text-lg font-semibold text-gray-800">
//                   Filters
//                 </h2>
//                 {activeFiltersCount > 0 && (
//                   <span className="ml-2 bg-blue-100 text-blue-800 text-xs font-medium px-2 py-1 rounded-full">
//                     {activeFiltersCount}
//                   </span>
//                 )}
//               </div>
//               <div className="flex items-center space-x-2">
//                 <button
//                   onClick={() => setShowFilters(!showFilters)}
//                   className="flex items-center text-gray-500 hover:text-gray-700 p-2 rounded-md hover:bg-gray-100 transition-colors"
//                 >
//                   {showFilters ? (
//                     <ChevronUp size={18} />
//                   ) : (
//                     <ChevronDown size={18} />
//                   )}
//                   <span className="hidden sm:inline ml-1">
//                     {showFilters ? "Hide" : "Show"}
//                   </span>
//                 </button>
//                 {activeFiltersCount > 0 && (
//                   <button
//                     onClick={resetFilters}
//                     className="text-blue-600 hover:text-blue-800 text-sm font-medium px-3 py-1 rounded-md hover:bg-blue-50 transition-colors"
//                   >
//                     Reset
//                   </button>
//                 )}
//               </div>
//             </div>
//           </div>

//           {showFilters && (
//             <div className="p-4">
//               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
//                 {/* Admin/Assigned Filter */}
//                 <div className="space-y-2">
//                   <label className="flex items-center text-sm font-medium text-gray-700">
//                     <UserCheck size={14} className="mr-2 text-blue-500" />
//                     Assigned To
//                   </label>
//                   <select
//                     className="w-full border border-gray-300 rounded-md p-2 text-sm text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                     name="assigned"
//                     value={filters.assigned}
//                     onChange={handleFilterChange}
//                   >
//                     <option value="">All Administrators</option>
//                     {admins
//                       .filter((admin) => admin.role === "admin")
//                       .map((admin) => (
//                         <option key={admin.admin_id} value={admin.admin_id}>
//                           {admin.username}
//                         </option>
//                       ))}
//                   </select>
//                 </div>

//                 {/* Branch Filter */}
//                 <div className="space-y-2">
//                   <label className="flex items-center text-sm font-medium text-gray-700">
//                     <Building size={14} className="mr-2 text-blue-500" />
//                     Branch
//                   </label>
//                   <select
//                     className="w-full border border-gray-300 rounded-md p-2 text-sm text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                     name="branch"
//                     value={filters.branch}
//                     onChange={handleFilterChange}
//                   >
//                     <option value="">All Branches</option>
//                     <option value="Vidhyavihar">Vidyavihar</option>
//                     <option value="Andheri">Andheri</option>
//                   </select>
//                 </div>

//                 {/* Service Type Filter */}
//                 <div className="space-y-2">
//                   <label className="flex items-center text-sm font-medium text-gray-700">
//                     <MapPin size={14} className="mr-2 text-blue-500" />
//                     Service Type
//                   </label>
//                   <select
//                     className="w-full border border-gray-300 rounded-md p-2 text-sm text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                     name="serviceType"
//                     value={filters.serviceType}
//                     onChange={handleFilterChange}
//                   >
//                     <option value="">All Services</option>
//                     {coreServices &&
//                       coreServices.map((service) => (
//                         <option
//                           key={service.id}
//                           value={service.core_service_name}
//                         >
//                           {service.core_service_name}
//                         </option>
//                       ))}
//                   </select>
//                 </div>

//                 {/* Country Filter */}
//                 <div className="space-y-2">
//                   <label className="flex items-center text-sm font-medium text-gray-700">
//                     <Flag size={14} className="mr-2 text-blue-500" />
//                     Country
//                   </label>
//                   <select
//                     className="w-full border border-gray-300 rounded-md p-2 text-sm text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                     name="country"
//                     value={filters.country}
//                     onChange={handleFilterChange}
//                   >
//                     <option value="">All Countries</option>
//                     {uniqueCountry.map((name) => (
//                       <option key={name} value={name}>
//                         {name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 {/* Intended Degree Filter */}
//                 <div className="space-y-2">
//                   <label className="flex items-center text-sm font-medium text-gray-700">
//                     <GraduationCap size={14} className="mr-2 text-blue-500" />
//                     Intended Degree
//                   </label>
//                   <select
//                     className="w-full border border-gray-300 rounded-md p-2 text-sm text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                     name="intendedDegree"
//                     value={filters.intendedDegree}
//                     onChange={handleFilterChange}
//                   >
//                     <option value="">All Degrees</option>
//                     <option value="Undergraduate/Bachelors">
//                       Undergraduate/Bachelors
//                     </option>
//                     <option value="PG Diploma">PG Diploma</option>
//                     <option value="Masters">Masters</option>
//                     <option value="MBA">MBA</option>
//                     <option value="Phd">PhD</option>
//                   </select>
//                 </div>

//                 {/* Intake Filter */}
//                 <div className="space-y-2">
//                   <label className="flex items-center text-sm font-medium text-gray-700">
//                     <Calendar size={14} className="mr-2 text-blue-500" />
//                     Intake
//                   </label>
//                   <select
//                     className="w-full border border-gray-300 rounded-md p-2 text-sm text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                     name="intake"
//                     value={filters.intake}
//                     onChange={handleFilterChange}
//                   >
//                     <option value="">All Intakes</option>
//                     {generateMonthYearOptions().map((option) => (
//                       <option key={option.value} value={option.value}>
//                         {option.label}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 {/* Date Range Filters */}
//                 <div className="space-y-2">
//                   <label className="flex items-center text-sm font-medium text-gray-700">
//                     <Calendar size={14} className="mr-2 text-blue-500" />
//                     From Date
//                   </label>
//                   <input
//                     type="date"
//                     name="fromDate"
//                     className="w-full border border-gray-300 rounded-md p-2 text-sm text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                     value={filters.fromDate}
//                     onChange={handleFilterChange}
//                   />
//                 </div>

//                 <div className="space-y-2">
//                   <label className="flex items-center text-sm font-medium text-gray-700">
//                     <Calendar size={14} className="mr-2 text-blue-500" />
//                     To Date
//                   </label>
//                   <input
//                     type="date"
//                     name="toDate"
//                     className="w-full border border-gray-300 rounded-md p-2 text-sm text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                     value={filters.toDate}
//                     onChange={handleFilterChange}
//                   />
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Results Section */}
//         <div className="bg-white rounded-lg shadow-sm overflow-hidden">
//           {/* Table Header with controls */}
//           <div className="px-4 sm:px-6 py-4 border-b border-gray-200">
//             <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
//               <div className="flex items-center gap-3">
//                 <h2 className="text-base sm:text-lg font-bold text-gray-800">
//                   Students
//                 </h2>
//                 <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
//                   {filteredBySearch.length} records
//                 </span>
//                 {selectedCustomers.length > 0 && (
//                   <span className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
//                     {selectedCustomers.length} selected
//                   </span>
//                 )}
//               </div>

//               <div className="flex items-center gap-3">
//                 {/* View Toggle - Mobile/Tablet */}
//                 <div className="lg:hidden flex bg-gray-100 rounded-lg p-1">
//                   <button
//                     onClick={() => setViewMode("cards")}
//                     className={`px-3 py-1 text-xs font-medium rounded-md transition-colors ${
//                       viewMode === "cards"
//                         ? "bg-white text-gray-900 shadow-sm"
//                         : "text-gray-600"
//                     }`}
//                   >
//                     Cards
//                   </button>
//                   <button
//                     onClick={() => setViewMode("table")}
//                     className={`px-3 py-1 text-xs font-medium rounded-md transition-colors ${
//                       viewMode === "table"
//                         ? "bg-white text-gray-900 shadow-sm"
//                         : "text-gray-600"
//                     }`}
//                   >
//                     Table
//                   </button>
//                 </div>

//                 {/* Per page selector */}
//                 <div className="flex items-center">
//                   <label className="text-sm text-gray-600 mr-2 hidden sm:inline">
//                     Per page:
//                   </label>
//                   <select
//                     value={customersPerPage}
//                     onChange={(e) => {
//                       const value =
//                         e.target.value === "all"
//                           ? filteredBySearch.length
//                           : Number(e.target.value);
//                       setCustomersPerPage(value);
//                       setCurrentPage(1);
//                     }}
//                     className="border border-gray-300 rounded-md p-1 text-sm text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                   >
//                     <option value="all">All</option>
//                     <option value={5}>5</option>
//                     <option value={10}>10</option>
//                     <option value={20}>20</option>
//                     <option value={50}>50</option>
//                     <option value={100}>100</option>
//                   </select>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Loading State */}
//           {isLoading ? (
//             <div className="p-12 sm:p-20 flex justify-center items-center">
//               <div className="animate-spin rounded-full h-8 w-8 sm:h-12 sm:w-12 border-t-2 border-b-2 border-blue-500"></div>
//             </div>
//           ) : (
//             <>
//               {/* Desktop Table View */}
//               {viewMode === "table" && (
//                 <div className="hidden lg:block">
//                   <div className="overflow-x-auto w-full">
//                     <table className="min-w-[1024px] w-full divide-y divide-gray-200">
//                       <thead className="bg-gray-50">
//                         <tr>
//                           <th className="px-6 py-3 text-left">
//                             <input
//                               type="checkbox"
//                               onChange={handleSelectAll}
//                               checked={
//                                 currentCustomers.length > 0 &&
//                                 selectedCustomers.length ===
//                                   currentCustomers.length
//                               }
//                               className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
//                             />
//                           </th>
//                           <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                             ID
//                           </th>
//                           <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                             Student Name
//                           </th>
//                           <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                             Email ID
//                           </th>
//                           <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                             <div
//                               className="flex items-center cursor-pointer hover:text-gray-700"
//                               onClick={() => {
//                                 setSortBy("created_at");
//                                 setSortOrder(
//                                   sortOrder === "asc" ? "desc" : "asc"
//                                 );
//                               }}
//                             >
//                               <span>Date Created</span>
//                               {sortBy === "created_at" && (
//                                 <span className="ml-1">
//                                   {sortOrder === "asc" ? "▲" : "▼"}
//                                 </span>
//                               )}
//                             </div>
//                           </th>
//                           <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                             Intake
//                           </th>
//                           <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                             Service Taken
//                           </th>
//                           <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                             Branch
//                           </th>
//                           <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                             Actions
//                           </th>
//                         </tr>
//                       </thead>
//                       <tbody className="bg-white divide-y divide-gray-200">
//                         {currentCustomers.length > 0 ? (
//                           currentCustomers.map((customer, index) => (
//                             <tr
//                               key={customer.id}
//                               className="hover:bg-gray-50 transition-colors"
//                             >
//                               <td className="px-6 py-4 whitespace-nowrap">
//                                 <input
//                                   type="checkbox"
//                                   checked={selectedCustomers.includes(
//                                     customer.id
//                                   )}
//                                   onChange={(e) => handleSelect(customer.id, e)}
//                                   className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
//                                 />
//                               </td>
//                               <td className="px-6 py-4 whitespace-nowrap">
//                                 <div className="text-sm text-gray-900">
//                                   {indexOfFirstCustomer + index + 1}
//                                 </div>
//                               </td>
//                               <td className="px-6 py-4 whitespace-nowrap">
//                                 <div className="flex items-center">
//                                   <div className="flex-shrink-0 h-10 w-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-800 font-medium">
//                                     {customer.name.charAt(0).toUpperCase()}
//                                   </div>
//                                   <div className="ml-4">
//                                     <div className="text-sm font-medium text-gray-900">
//                                       {customer.name}
//                                     </div>
//                                     <div className="text-sm text-gray-500">
//                                       {capitalizeName(
//                                         getAssignedName(customer.assigned_to)
//                                       )}
//                                     </div>
//                                   </div>
//                                 </div>
//                               </td>
//                               <td className="px-6 py-4 whitespace-nowrap">
//                                 <div className="text-sm text-gray-900">
//                                   {customer.email}
//                                 </div>
//                                 <div className="text-xs text-gray-500">
//                                   {customer.phone || "No phone"}
//                                 </div>
//                               </td>
//                               <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                                 {formatDateTime(customer.created_at) || "-"}
//                               </td>
//                               <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                                 {customer.intake || "-"}
//                               </td>
//                               <td className="px-6 py-4">
//                                 <div className="text-sm text-gray-900">
//                                   {formatServices(customer.services)}
//                                 </div>
//                               </td>
//                               <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                                 {customer.branch ? (
//                                   <span className="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
//                                     {customer.branch}
//                                   </span>
//                                 ) : (
//                                   "-"
//                                 )}
//                               </td>
//                               <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
//                                 <button
//                                   onClick={() => handleRowClick(customer.id)}
//                                   className="text-blue-600 hover:text-blue-900 bg-blue-50 hover:bg-blue-100 px-3 py-1 rounded-md transition-colors flex items-center"
//                                 >
//                                   <Eye size={16} className="mr-1" />
//                                   View
//                                 </button>
//                               </td>
//                             </tr>
//                           ))
//                         ) : (
//                           <tr>
//                             <td
//                               colSpan="9"
//                               className="px-6 py-12 text-center text-gray-500"
//                             >
//                               <div className="flex flex-col items-center">
//                                 <Search className="h-12 w-12 text-gray-300 mb-3" />
//                                 <p className="text-lg font-medium mb-1">
//                                   No students found
//                                 </p>
//                                 <p className="text-sm">
//                                   Try adjusting your filters or search terms
//                                 </p>
//                               </div>
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               )}

//               {/* Mobile/Tablet Table View */}

//               {viewMode === "table" && (
//                 <div className="lg:hidden block overflow-x-auto">
//                   <table className="min-w-full divide-y divide-gray-200">
//                     <thead className="bg-gray-50">
//                       <tr>
//                         <th className="px-3 py-3 text-left">
//                           <input
//                             type="checkbox"
//                             onChange={handleSelectAll}
//                             checked={
//                               currentCustomers.length > 0 &&
//                               selectedCustomers.length ===
//                                 currentCustomers.length
//                             }
//                             className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
//                           />
//                         </th>
//                         <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                           Student
//                         </th>
//                         <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                           Details
//                         </th>
//                         <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                           Action
//                         </th>
//                       </tr>
//                     </thead>
//                     <tbody className="bg-white divide-y divide-gray-200">
//                       {currentCustomers.length > 0 ? (
//                         currentCustomers.map((customer, index) => (
//                           <tr
//                             key={customer.id}
//                             className="hover:bg-gray-50 transition-colors"
//                           >
//                             <td className="px-3 py-4 whitespace-nowrap">
//                               <input
//                                 type="checkbox"
//                                 checked={selectedCustomers.includes(
//                                   customer.id
//                                 )}
//                                 onChange={(e) => handleSelect(customer.id, e)}
//                                 className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
//                               />
//                             </td>
//                             <td className="px-3 py-4">
//                               <div className="flex items-center">
//                                 <div className="flex-shrink-0 h-8 w-8 bg-blue-100 rounded-full flex items-center justify-center text-blue-800 font-medium text-sm">
//                                   {customer.name.charAt(0).toUpperCase()}
//                                 </div>
//                                 <div className="ml-3">
//                                   <div className="text-sm font-medium text-gray-900">
//                                     {customer.name}
//                                   </div>
//                                   <div className="text-xs text-gray-500">
//                                     {customer.email}
//                                   </div>
//                                 </div>
//                               </div>
//                             </td>
//                             <td className="px-3 py-4">
//                               <div className="text-xs text-gray-500 space-y-1">
//                                 <div>
//                                   <span className="font-medium">Created:</span>{" "}
//                                   {formatDateTime(customer.created_at) || "-"}
//                                 </div>
//                                 <div>
//                                   <span className="font-medium">Intake:</span>{" "}
//                                   {customer.intake || "-"}
//                                 </div>
//                                 <div>
//                                   <span className="font-medium">Branch:</span>{" "}
//                                   {customer.branch ? (
//                                     <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
//                                       {customer.branch}
//                                     </span>
//                                   ) : (
//                                     "-"
//                                   )}
//                                 </div>
//                               </div>
//                             </td>
//                             <td className="px-3 py-4 whitespace-nowrap">
//                               <button
//                                 onClick={() => handleRowClick(customer.id)}
//                                 className="text-blue-600 hover:text-blue-900 bg-blue-50 hover:bg-blue-100 px-2 py-1 rounded-md transition-colors flex items-center text-xs"
//                               >
//                                 <Eye size={14} className="mr-1" />
//                                 View
//                               </button>
//                             </td>
//                           </tr>
//                         ))
//                       ) : (
//                         <tr>
//                           <td
//                             colSpan="4"
//                             className="px-6 py-12 text-center text-gray-500"
//                           >
//                             <div className="flex flex-col items-center">
//                               <Search className="h-8 w-8 text-gray-300 mb-2" />
//                               <p className="text-sm font-medium mb-1">
//                                 No students found
//                               </p>
//                               <p className="text-xs">
//                                 Try adjusting your filters or search terms
//                               </p>
//                             </div>
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               )}

//               {/* Mobile Card View */}
//               <div
//                 className="lg:hidden"
//                 style={{ display: viewMode === "cards" ? "block" : "none" }}
//               >
//                 {currentCustomers.length > 0 ? (
//                   <div className="p-4 space-y-4">
//                     {currentCustomers.map((customer, index) => (
//                       <div
//                         key={customer.id}
//                         className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow"
//                       >
//                         <div className="flex items-start justify-between mb-3">
//                           <div className="flex items-center">
//                             <input
//                               type="checkbox"
//                               checked={selectedCustomers.includes(customer.id)}
//                               onChange={(e) => handleSelect(customer.id, e)}
//                               className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500 mr-3"
//                             />
//                             <div className="flex-shrink-0 h-10 w-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-800 font-medium">
//                               {customer.name.charAt(0).toUpperCase()}
//                             </div>
//                             <div className="ml-3">
//                               <div className="text-sm font-semibold text-gray-900">
//                                 {customer.name}
//                               </div>
//                               <div className="text-xs text-gray-500">
//                                 ID: {indexOfFirstCustomer + index + 1}
//                               </div>
//                             </div>
//                           </div>
//                           <button
//                             onClick={() => handleRowClick(customer.id)}
//                             className="text-blue-600 hover:text-blue-900 bg-blue-50 hover:bg-blue-100 px-3 py-1 rounded-md transition-colors flex items-center text-sm"
//                           >
//                             <Eye size={14} className="mr-1" />
//                             View
//                           </button>
//                         </div>

//                         <div className="grid grid-cols-2 gap-3 text-xs">
//                           <div>
//                             <span className="font-medium text-gray-700">
//                               Email:
//                             </span>
//                             <div className="text-gray-600 truncate">
//                               {customer.email}
//                             </div>
//                           </div>
//                           <div>
//                             <span className="font-medium text-gray-700">
//                               Phone:
//                             </span>
//                             <div className="text-gray-600">
//                               {customer.phone || "N/A"}
//                             </div>
//                           </div>
//                           <div>
//                             <span className="font-medium text-gray-700">
//                               Created:
//                             </span>
//                             <div className="text-gray-600">
//                               {formatDateTime(customer.created_at) || "-"}
//                             </div>
//                           </div>
//                           <div>
//                             <span className="font-medium text-gray-700">
//                               Intake:
//                             </span>
//                             <div className="text-gray-600">
//                               {customer.intake || "-"}
//                             </div>
//                           </div>
//                           <div>
//                             <span className="font-medium text-gray-700">
//                               Branch:
//                             </span>
//                             <div className="text-gray-600">
//                               {customer.branch ? (
//                                 <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
//                                   {customer.branch}
//                                 </span>
//                               ) : (
//                                 "-"
//                               )}
//                             </div>
//                           </div>
//                           <div>
//                             <span className="font-medium text-gray-700">
//                               Assigned:
//                             </span>
//                             <div className="text-gray-600">
//                               {getAssignedName(customer.assigned_to)}
//                             </div>
//                           </div>
//                         </div>

//                         <div className="mt-3 pt-3 border-t border-gray-100">
//                           <span className="font-medium text-gray-700 text-xs">
//                             Services:
//                           </span>
//                           <div className="text-gray-600 text-xs mt-1">
//                             {formatServices(customer.services)}
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 ) : (
//                   <div className="p-12 text-center text-gray-500">
//                     <div className="flex flex-col items-center">
//                       <Search className="h-12 w-12 text-gray-300 mb-3" />
//                       <p className="text-lg font-medium mb-1">
//                         No students found
//                       </p>
//                       <p className="text-sm">
//                         Try adjusting your filters or search terms
//                       </p>
//                     </div>
//                   </div>
//                 )}
//               </div>

//               {/* Pagination */}
//               {filteredBySearch.length > 0 && (
//                 <div className="bg-gray-50 px-4 sm:px-6 py-4 border-t border-gray-200">
//                   <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
//                     {/* Results info */}
//                     <div className="text-sm text-gray-700 text-center sm:text-left">
//                       Showing{" "}
//                       <span className="font-medium">
//                         {indexOfFirstCustomer + 1}
//                       </span>{" "}
//                       to{" "}
//                       <span className="font-medium">
//                         {Math.min(indexOfLastCustomer, filteredBySearch.length)}
//                       </span>{" "}
//                       of{" "}
//                       <span className="font-medium">
//                         {filteredBySearch.length}
//                       </span>{" "}
//                       students
//                     </div>

//                     {/* Pagination controls */}
//                     <div className="flex items-center">
//                       <nav
//                         className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
//                         aria-label="Pagination"
//                       >
//                         {/* First page button */}
//                         <button
//                           onClick={() => paginate(1)}
//                           disabled={currentPage === 1}
//                           className={`relative inline-flex items-center px-2 py-2 rounded-l-md border text-sm font-medium ${
//                             currentPage === 1
//                               ? "bg-gray-100 border-gray-300 text-gray-400 cursor-not-allowed"
//                               : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50"
//                           }`}
//                         >
//                           <span className="sr-only">First</span>
//                           <ChevronsLeft className="h-4 w-4" />
//                         </button>

//                         {/* Previous page button */}
//                         <button
//                           onClick={() => paginate(currentPage - 1)}
//                           disabled={currentPage === 1}
//                           className={`relative inline-flex items-center px-2 py-2 border text-sm font-medium ${
//                             currentPage === 1
//                               ? "bg-gray-100 border-gray-300 text-gray-400 cursor-not-allowed"
//                               : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50"
//                           }`}
//                         >
//                           <span className="sr-only">Previous</span>
//                           <ChevronLeft className="h-4 w-4" />
//                         </button>

//                         {/* Page number buttons - show fewer on mobile */}
//                         {[
//                           ...Array(
//                             Math.min(
//                               window.innerWidth < 640 ? 3 : 5,
//                               totalPages
//                             )
//                           ),
//                         ].map((_, i) => {
//                           let pageNum;
//                           const maxPages = window.innerWidth < 640 ? 3 : 5;

//                           if (totalPages <= maxPages) {
//                             pageNum = i + 1;
//                           } else if (
//                             currentPage <=
//                             Math.floor(maxPages / 2) + 1
//                           ) {
//                             pageNum = i + 1;
//                           } else if (
//                             currentPage >=
//                             totalPages - Math.floor(maxPages / 2)
//                           ) {
//                             pageNum = totalPages - maxPages + 1 + i;
//                           } else {
//                             pageNum =
//                               currentPage - Math.floor(maxPages / 2) + i;
//                           }

//                           if (pageNum > totalPages) return null;

//                           return (
//                             <button
//                               key={pageNum}
//                               onClick={() => paginate(pageNum)}
//                               className={`relative inline-flex items-center px-3 sm:px-4 py-2 border text-sm font-medium ${
//                                 currentPage === pageNum
//                                   ? "z-10 bg-blue-50 border-blue-500 text-blue-600"
//                                   : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50"
//                               }`}
//                             >
//                               {pageNum}
//                             </button>
//                           );
//                         })}

//                         {/* Next page button */}
//                         <button
//                           onClick={() => paginate(currentPage + 1)}
//                           disabled={currentPage === totalPages}
//                           className={`relative inline-flex items-center px-2 py-2 border text-sm font-medium ${
//                             currentPage === totalPages
//                               ? "bg-gray-100 border-gray-300 text-gray-400 cursor-not-allowed"
//                               : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50"
//                           }`}
//                         >
//                           <span className="sr-only">Next</span>
//                           <ChevronRight className="h-4 w-4" />
//                         </button>

//                         {/* Last page button */}
//                         <button
//                           onClick={() => paginate(totalPages)}
//                           disabled={currentPage === totalPages}
//                           className={`relative inline-flex items-center px-2 py-2 rounded-r-md border text-sm font-medium ${
//                             currentPage === totalPages
//                               ? "bg-gray-100 border-gray-300 text-gray-400 cursor-not-allowed"
//                               : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50"
//                           }`}
//                         >
//                           <span className="sr-only">Last</span>
//                           <ChevronsRight className="h-4 w-4" />
//                         </button>
//                       </nav>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CustomerList;

import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";

import {
  getCustomers,
  getCustomer,
  deleteCustomer,
  updateCustomer,
} from "../../../services/customer.services";

import {
  setAllCustomers,
  updateCustomerStatus,
  setCustomerDetail,
  applyFilters,
} from "../../../state/reducers/customerSlice";
import { formatDateTime } from "../../../utils/dateFormat";
import { getNewTable } from "../../../services/mainServices.services";

import {
  Search,
  Download,
  FileSpreadsheet,
  Filter,
  X,
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
  Eye,
  Calendar,
  UserCheck,
  MapPin,
  Flag,
  GraduationCap,
  Building,
  Menu,
  ChevronDown,
  ChevronUp,
  Check,
  User,
} from "lucide-react";

const ARCHIVE_PREFIX = "__ARCHIVED__::";

// Multi-Select Dropdown Component
const MultiSelectDropdown = ({
  options,
  selectedValues,
  onChange,
  placeholder = "Select options...",
  icon: Icon,
  disabled = false,
  showSearch = true,
  searchPlaceholder = "Search options...",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const searchInputRef = useRef(null);
  const filteredOptions = showSearch
    ? options.filter(
        (option) =>
          option.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
          option.value.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : options;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        if (showSearch) {
          setSearchTerm("");
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showSearch]);
  useEffect(() => {
    if (isOpen && showSearch && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isOpen, showSearch]);
  const handleDropdownToggle = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
      if (!isOpen && showSearch) {
        setSearchTerm("");
      }
    }
  };

  const handleOptionToggle = (optionValue) => {
    const newSelectedValues = selectedValues.includes(optionValue)
      ? selectedValues.filter((value) => value !== optionValue)
      : [...selectedValues, optionValue];

    onChange(newSelectedValues);
  };

  const handleSelectAll = () => {
    if (selectedValues.length === filteredOptions.length) {
      const filteredValues = filteredOptions.map((option) => option.value);
      const newSelectedValues = selectedValues.filter(
        (value) => !filteredValues.includes(value)
      );
      onChange(newSelectedValues);
    } else {
      const filteredValues = filteredOptions.map((option) => option.value);
      const newSelectedValues = [
        ...new Set([...selectedValues, ...filteredValues]),
      ];
      onChange(newSelectedValues);
    }
  };

  const handleClearAll = () => {
    if (showSearch && searchTerm) {
      const filteredValues = filteredOptions.map((option) => option.value);
      const newSelectedValues = selectedValues.filter(
        (value) => !filteredValues.includes(value)
      );
      onChange(newSelectedValues);
    } else {
      onChange([]);
    }
  };
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const clearSearch = () => {
    setSearchTerm("");
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  };

  const getDisplayText = () => {
    if (selectedValues.length === 0) return placeholder;
    if (selectedValues.length === 1) {
      const option = options.find((opt) => opt.value === selectedValues[0]);
      return option ? option.label : selectedValues[0];
    }
    return `${selectedValues.length} selected`;
  };
  const allFilteredSelected =
    filteredOptions.length > 0 &&
    filteredOptions.every((option) => selectedValues.includes(option.value));
  return (
    <div className="relative " ref={dropdownRef}>
      <button
        type="button"
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled}
        className={`w-full border border-gray-300 rounded-md p-2 text-sm text-left focus:ring-2 focus:ring-blue-500 focus:border-transparent flex items-center justify-between ${
          disabled
            ? "bg-gray-100 cursor-not-allowed"
            : "bg-white hover:bg-gray-50"
        }`}
      >
        <div className="flex items-center  flex-1 min-w-0">
          {Icon && (
            <Icon size={14} className="mr-2 text-blue-500 flex-shrink-0" />
          )}
          <span
            className={`truncate ${
              selectedValues.length === 0 ? "text-gray-500" : "text-gray-700"
            }`}
          >
            {getDisplayText()}
          </span>
          {selectedValues.length > 0 && (
            <span className="ml-2 bg-blue-100 text-blue-800 text-xs font-medium px-2 py-0.5 rounded-full flex-shrink-0">
              {selectedValues.length}
            </span>
          )}
        </div>
        {isOpen ? (
          <ChevronUp size={16} className="text-gray-400" />
        ) : (
          <ChevronDown size={16} className="text-gray-400" />
        )}
      </button>

      {isOpen && (
        <div className=" z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto">
          {/* Header with Select All/Clear All */}
          {showSearch && (
            <div className="sticky top-0 bg-white px-3 py-2 border-b border-gray-200 z-10">
              <div className="relative">
                <input
                  ref={searchInputRef}
                  type="text"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  placeholder={searchPlaceholder}
                  className="w-full pl-8 pr-8 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                <Search
                  size={16}
                  className="absolute left-2.5 top-2.5 text-gray-400"
                />
                {searchTerm && (
                  <button
                    onClick={clearSearch}
                    className="absolute right-2.5 top-2.5 text-gray-400 hover:text-gray-600"
                  >
                    <X size={16} />
                  </button>
                )}
              </div>
            </div>
          )}
          <div className="sticky top-0 bg-gray-50 px-3 py-2 border-b border-gray-200 flex justify-between items-center">
            <button
              type="button"
              onClick={handleSelectAll}
              className="text-xs text-blue-600 hover:text-blue-800 font-medium"
            >
              {selectedValues.length === options.length
                ? "Deselect All"
                : "Select All"}
            </button>
            {selectedValues.length > 0 && (
              <button
                type="button"
                onClick={handleClearAll}
                className="text-xs text-red-600 hover:text-red-800 font-medium"
              >
                Clear All
              </button>
            )}
          </div>

          {/* Options List */}
          {/* Options List */}
          <div className="py-1 max-h-60 overflow-y-auto">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option) => (
                <label
                  key={option.value}
                  className="flex items-center px-3 py-2 hover:bg-gray-100 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    checked={selectedValues.includes(option.value)}
                    onChange={() => handleOptionToggle(option.value)}
                    className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500 mr-3"
                  />
                  <span className="text-sm text-gray-700 flex-1">
                    {option.label}
                  </span>
                  {selectedValues.includes(option.value) && (
                    <Check size={14} className="text-blue-600 ml-2" />
                  )}
                </label>
              ))
            ) : (
              <div className="px-3 py-4 text-center">
                <Search className="h-8 w-8 mx-auto text-gray-300 mb-2" />
                <p className="text-sm text-gray-500">
                  {showSearch && searchTerm
                    ? `No options found for "${searchTerm}"`
                    : "No options available"}
                </p>
              </div>
            )}
          </div>

          {options.length === 0 && (
            <div className="px-3 py-2 text-sm text-gray-500 text-center">
              No options available
            </div>
          )}
        </div>
      )}
    </div>
  );
};

// Selected Values Display Component
const SelectedValuesDisplay = ({
  selectedValues,
  options,
  onRemove,
  label,
}) => {
  if (selectedValues.length === 0) return null;

  return (
    <div className="mt-2">
      <div className="text-xs text-gray-600 mb-1">{label}:</div>
      <div className="flex flex-wrap gap-1">
        {selectedValues.map((value) => {
          const option = options.find((opt) => opt.value === value);
          const displayName = option ? option.label : value;

          return (
            <span
              key={value}
              className="inline-flex items-center px-2 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded-full"
            >
              {displayName}
              <button
                type="button"
                onClick={() => onRemove(value)}
                className="ml-1 text-blue-600 hover:text-blue-800"
              >
                <X size={12} />
              </button>
            </span>
          );
        })}
      </div>
    </div>
  );
};

const CustomerList = ({ archived = false }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const admins = useSelector((state) => state.admin.admins);
  const allCustomers = useSelector((state) => state.customer.allCustomers);
  const allLoaded = useSelector((state) => state.customer.allCustomersLoaded);
  const [currentPage, setCurrentPage] = useState(1);
  const [customersPerPage, setCustomersPerPage] = useState(10);
  const filteredCustomer = useSelector(
    (state) => state.customer.filteredCustomers
  );

  const customers = React.useMemo(() => {
    return allCustomers.filter((row) => {
      const isArch = (row?.status || "").startsWith(ARCHIVE_PREFIX);
      return archived ? isArch : !isArch;
    });
  }, [allCustomers, archived]);

  // Local states
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [coreServices, setCoreServices] = useState([]);
  const [sortedCustomers, setSortedCustomers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [sortBy, setSortBy] = useState("created_at");
  const [sortOrder, setSortOrder] = useState("desc");
  const [viewMode, setViewMode] = useState("table");


  // Updated filters state to use arrays for multi-select
  const [filters, setFilters] = useState({
    assigned: [],
    serviceType: [],
    branch: [],
    country: [],
    intendedDegree: [],
    intake: [],
    fromDate: "",
    toDate: "",
    contentWriter: [],
    applicationManager: [],
    visaManager: [],
    loanManager: [],
  });

  const adminToOption = (admin) => ({
    value: admin.admin_id.toString(),
    label: admin.username,
  });

  // Get unique countries from customer data
  const uniqueCountry = Array.from(
    new Set(customers.flatMap((customer) => customer.preferred_countries))
  );
  console.log("uniqueCountry", uniqueCountry);

  // Prepare options for multi-select dropdowns
  const filterOptions = {
    assigned: admins
      .filter((admin) => admin.role === "admin")
      .map((admin) => ({
        value: admin.admin_id.toString(),
        label: admin.username,
      })),

    contentWriter: admins.filter((a) => a.role === "admin").map(adminToOption),

    applicationManager: admins
      .filter((a) => a.role === "admin")
      .map(adminToOption),

    visaManager: admins.filter((a) => a.role === "admin").map(adminToOption),

    loanManager: admins.filter((a) => a.role === "admin").map(adminToOption),

    serviceType: coreServices.map((service) => ({
      value: service.core_service_name,
      label: service.core_service_name,
    })),

    branch: [
      { value: "Vidhyavihar", label: "Vidyavihar" },
      { value: "Andheri", label: "Andheri" },
    ],

    country: uniqueCountry.map((country) => ({
      value: country,
      label: country,
    })),

    intendedDegree: [
      { value: "Undergraduate/Bachelors", label: "Undergraduate/Bachelors" },
      { value: "PG Diploma", label: "PG Diploma" },
      { value: "Masters", label: "Masters" },
      { value: "MBA", label: "MBA" },
      { value: "Phd", label: "PhD" },
    ],

    intake: (() => {
      const options = [];
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();

      for (let year = currentYear - 5; year <= currentYear + 5; year++) {
        for (let month = 0; month < 12; month++) {
          const date = new Date(year, month);
          const formattedDate =
            date.toLocaleString("default", { month: "short" }) + "-" + year;
          options.push({
            value: `${year}-${month + 1 < 10 ? "0" : ""}${month + 1}`,
            label: formattedDate,
          });
        }
      }
      return options;
    })(),
  };
  console.log("customer", customers);

  // Updated filter logic to handle arrays
  useEffect(() => {
    if (customers && customers.length > 0) {
      let result = [...customers];

      // Apply assigned filter
      if (filters.assigned.length > 0) {
        result = result.filter(
          (customer) =>
            customer.assigned_to &&
            filters.assigned.includes(customer.assigned_to.toString())
        );
      }

      if (filters.contentWriter.length > 0) {
        result = result.filter(
          (c) =>
            c.assigned_content_writer &&
            filters.contentWriter.includes(String(c.assigned_content_writer))
        );
      }

      // ✅ Filter: Application Manager
      if (filters.applicationManager.length > 0) {
        result = result.filter(
          (c) =>
            c.assigned_application_manager &&
            filters.applicationManager.includes(
              String(c.assigned_application_manager)
            )
        );
      }

      // ✅ Filter: Visa Manager
      if (filters.visaManager.length > 0) {
        result = result.filter(
          (c) =>
            c.assigned_visa_manager &&
            filters.visaManager.includes(String(c.assigned_visa_manager))
        );
      }

      // ✅ Filter: Loan Manager
      if (filters.loanManager.length > 0) {
        result = result.filter(
          (c) =>
            c.assigned_loan_manager &&
            filters.loanManager.includes(String(c.assigned_loan_manager))
        );
      }

      // Apply branch filter
      if (filters.branch.length > 0) {
        result = result.filter((customer) =>
          filters.branch.includes(customer.branch)
        );
      }

      // Apply service type filter
      if (filters.serviceType.length > 0) {
        result = result.filter((customer) =>
          customer.services.some((service) =>
            filters.serviceType.includes(service.coreservice_name)
          )
        );
      }

      // Apply country filter
      if (filters.country.length > 0) {
        result = result.filter((customer) =>
          customer.preferred_countries.some((country) =>
            filters.country.includes(country)
          )
        );
      }

      // Apply intended degree filter
      if (filters.intendedDegree?.length) {
        const selected = new Set(
          filters.intendedDegree.map((s) => s.trim().toLowerCase())
        );

        // Did the user pick an Undergraduate option?
        const ugSelected =
          selected.has("undergraduate") ||
          selected.has("undergraduate/bachelors");

        result = result.filter((c) => {
          const d = (c.intended_degree || "").trim().toLowerCase();

          // If UG was selected, accept common UG variants
          if (ugSelected) {
            if (
              d === "undergraduate" ||
              d === "Undergraduate" ||
              d === "undergraduate/bachelors" ||
              d === "bachelors"
            ) {
              return true;
            }
          }

          // Otherwise do normal exact match against the selected values
          return selected.has(d);
        });
      }

      // Apply intake filter
      if (filters.intake.length > 0) {
        result = result.filter((customer) => {
          const customerIntakeMonthYear = customer.intake
            ? customer.intake.slice(0, 7)
            : "";
          return filters.intake.includes(customerIntakeMonthYear);
        });
      }

      // Apply date range filter
      if (filters.fromDate && filters.toDate) {
        const fromDateFilter = new Date(filters.fromDate);
        const toDateFilter = new Date(filters.toDate);
        toDateFilter.setDate(toDateFilter.getDate() + 1);

        result = result.filter((customer) => {
          const customerDate = new Date(customer.created_at);
          return customerDate >= fromDateFilter && customerDate <= toDateFilter;
        });
      }

      // Apply sorting
      result.sort((a, b) => {
        const aValue = a[sortBy] || "";
        const bValue = b[sortBy] || "";

        if (sortOrder === "asc") {
          return aValue.localeCompare(bValue);
        } else {
          return bValue.localeCompare(aValue);
        }
      });

      setSortedCustomers(result);
    } else {
      setSortedCustomers([]);
    }
  }, [customers, filters, sortBy, sortOrder]);

  const fetchAllCustomers = async () => {
    setIsLoading(true);
    try {
      const response = await getCustomers();
      const allData = Array.isArray(response?.data?.data) ? response.data.data : [];
      dispatch(setAllCustomers(allData));
    } catch (err) {
      console.error("Error fetching all customers:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCoreServices = async () => {
    try {
      const data = await getNewTable();
      setCoreServices(data);
    } catch (error) {
      console.error("Failed to fetch core services:", error);
    }
  };

  useEffect(() => {
    if (!allLoaded) {
      fetchAllCustomers();
    } else {
      setIsLoading(false);
    }
    fetchCoreServices();
  }, [dispatch]);

  // Handle row click to view customer details
  const handleRowClick = async (id) => {
    try {
      const response = await getCustomer(id);
      dispatch(setCustomerDetail(response.data));
      navigate(`${id}`);
    } catch (error) {
      console.error("Failed to fetch customer detail:", error);
    }
  };

  const handleArchiveToggle = async (id, shouldArchive, e) => {
    if (e) e.stopPropagation();
    const target = allCustomers.find((c) => c.id === id);
    if (!target) return;
    const currentStatus = target.status || "";
    const baseStatus = currentStatus.startsWith(ARCHIVE_PREFIX)
      ? currentStatus.slice(ARCHIVE_PREFIX.length)
      : currentStatus;
    const newStatus = shouldArchive
      ? `${ARCHIVE_PREFIX}${baseStatus}`
      : baseStatus;

    dispatch(updateCustomerStatus({ id, status: newStatus }));
    setSelectedCustomers((prev) => prev.filter((cid) => cid !== id));

    try {
      await updateCustomer(id, { status: newStatus });
      toast.success(
        shouldArchive
          ? "Customer archived successfully"
          : "Customer unarchived successfully"
      );
    } catch (error) {
      console.error("Archive PATCH failed:", error?.response?.data || error);
      dispatch(updateCustomerStatus({ id, status: currentStatus }));
      toast.error("Unable to update archive status. Please try again.");
    }
  };

  // Handle selection of single checkbox
  const handleSelect = (id, e) => {
    e.stopPropagation();
    setSelectedCustomers((prev) =>
      prev.includes(id)
        ? prev.filter((customerId) => customerId !== id)
        : [...prev, id]
    );
  };

  // Handle "Select All" checkbox
  const handleSelectAll = (e) => {
    if (selectedCustomers.length === currentCustomers.length) {
      setSelectedCustomers([]);
    } else {
      setSelectedCustomers(currentCustomers.map((c) => c.id));
    }
  };

  // Export selected customers to Excel
  const handleExportSelected = () => {
    if (selectedCustomers.length === 0) {
      toast.error("No customers selected to export!");
      return;
    }

    const selectedData = customers.filter((c) =>
      selectedCustomers.includes(c.id)
    );

    const formattedData = selectedData.map((customer, index) => ({
      "S.No": index + 1,
      Name: customer.name || "-",
      Email: customer.email || "-",
      Phone: customer.phone || "-",
      Address: customer.address || "-",
      Intake: customer.intake || "-",
      "Preferred Countries": customer.preferred_countries?.join(", ") || "-",
      "Service Taken Details":
        customer.services
          .map((service) => service.coreservice_name)
          .join(", ") || "-",
      Branch: customer.branch || "-",
      Status: customer.status || "-",
      "Parents' Email": customer.parents_email || "-",
      "Alternate Contact Number": customer.alternate_contact_number || "-",
      "Assigned Content Writer": customer.assigned_content_writer || "-",
      "Assigned To":
        admins.find((admin) => admin.admin_id == customer.assigned_to)
          ?.username || "-",
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Selected Customers");
    XLSX.writeFile(workbook, "Selected_Customers.xlsx");

    toast.success("Selected customers exported successfully!");
  };

  // Handle multi-select filter change
  const handleFilterChange = (filterName, selectedValues) => {
    setFilters((prev) => ({
      ...prev,
      [filterName]: selectedValues,
    }));
    dispatch(
      applyFilters({ filters: { ...filters, [filterName]: selectedValues } })
    );
  };

  // Handle removing single filter value
  const handleRemoveFilterValue = (filterName, valueToRemove) => {
    const newValues = filters[filterName].filter(
      (value) => value !== valueToRemove
    );
    handleFilterChange(filterName, newValues);
  };

  // Handle date filter change (for date inputs)
  const handleDateFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
    dispatch(applyFilters({ filters: { ...filters, [name]: value } }));
  };

  // Reset all filters
  const resetFilters = () => {
    setFilters({
      assigned: [],
      serviceType: [],
      branch: [],
      country: [],
      intendedDegree: [],
      intake: [],
      fromDate: "",
      toDate: "",
      contentWriter: [],
      applicationManager: [],
      visaManager: [],
      loanManager: [],
    });
    setSearchQuery("");
    dispatch(applyFilters({ filters: {} }));
  };

  // Filter customers by search query
  const filteredBySearch = sortedCustomers.filter((customer) =>
    `${customer.name} ${customer.email}`
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  // Pagination
  const indexOfLastCustomer = currentPage * customersPerPage;
  const indexOfFirstCustomer = indexOfLastCustomer - customersPerPage;
  const currentCustomers = filteredBySearch.slice(
    indexOfFirstCustomer,
    indexOfLastCustomer
  );
  const totalPages = Math.ceil(filteredBySearch.length / customersPerPage);

  // Change page
  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  // Format service names for display
  const formatServices = (services) => {
    if (!services || services.length === 0) return "-";
    return services
      .map((service) => service.coreservice_name)
      .filter((name) => name)
      .join(", ");
  };

  // Get assigned admin name
  const getAssignedName = (assignedId) => {
    const admin = admins.find((admin) => admin.admin_id == assignedId);
    return admin ? admin.username : "-";
  };

  // Toast notification function (simplified version)
  const toast = {
    success: (message) => alert(message),
    error: (message) => alert(message),
  };

  // Count active filters
  const activeFiltersCount = Object.values(filters).reduce(
    (count, filterValue) => {
      if (Array.isArray(filterValue)) {
        return count + filterValue.length;
      }
      return count + (filterValue !== "" ? 1 : 0);
    },
    0
  );

  function capitalizeName(name) {
    return name
      ?.split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="p-3 sm:p-4 lg:p-6 max-w-full mx-auto">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6 mb-4 sm:mb-6">
          <div className="flex flex-col space-y-4 sm:space-y-0 sm:flex-row sm:justify-between sm:items-start">
            <div className="flex-1">
              <h1 className="text-xl sm:text-2xl font-bold text-gray-800">
                {archived ? "Archived Customers" : "Students Database"}
              </h1>
              <p className="text-gray-500 mt-1 text-sm sm:text-base">
                {archived
                  ? "Manage archived customers"
                  : "Manage and view all students in the system"}
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-3">
              {/* Search Input */}
              <div className="relative flex-1 sm:flex-none sm:w-64">
                <input
                  type="text"
                  placeholder="Search students..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-700 text-sm"
                />
                <Search
                  className="absolute left-3 top-2.5 text-gray-400"
                  size={16}
                />
              </div>

              {/* Export Button */}
              <button
                onClick={handleExportSelected}
                disabled={selectedCustomers.length === 0}
                className={`flex items-center justify-center px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  selectedCustomers.length === 0
                    ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                    : "bg-green-600 text-white hover:bg-green-700"
                }`}
              >
                <FileSpreadsheet size={16} className="mr-2" />
                <span className="hidden sm:inline">Export</span>
                {selectedCustomers.length > 0 && (
                  <span className="ml-1">({selectedCustomers.length})</span>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Filters Section */}
        <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-4 sm:mb-6">
          <div className="p-4 border-b border-gray-200">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <Filter className="text-gray-500 mr-2" size={18} />
                <h2 className="text-base sm:text-lg font-semibold text-gray-800">
                  Filters
                </h2>
                {activeFiltersCount > 0 && (
                  <span className="ml-2 bg-blue-100 text-blue-800 text-xs font-medium px-2 py-1 rounded-full">
                    {activeFiltersCount}
                  </span>
                )}
              </div>
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => setShowFilters(!showFilters)}
                  className="flex items-center text-gray-500 hover:text-gray-700 p-2 rounded-md hover:bg-gray-100 transition-colors"
                >
                  {showFilters ? (
                    <ChevronUp size={18} />
                  ) : (
                    <ChevronDown size={18} />
                  )}
                  <span className="hidden sm:inline ml-1">
                    {showFilters ? "Hide" : "Show"}
                  </span>
                </button>
                {activeFiltersCount > 0 && (
                  <button
                    onClick={resetFilters}
                    className="text-blue-600 hover:text-blue-800 text-sm font-medium px-3 py-1 rounded-md hover:bg-blue-50 transition-colors"
                  >
                    Reset
                  </button>
                )}
              </div>
            </div>
          </div>

          {showFilters && (
            <div className="p-4 relative" style={{ minHeight: "320px" }}>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 relative">
                {/* First Row - Higher z-index */}
                {/* Admin/Assigned Filter */}
                <div className="space-y-2 relative" style={{ zIndex: 45 }}>
                  <label className="flex items-center text-sm font-medium text-gray-700">
                    <UserCheck size={14} className="mr-2 text-blue-500" />
                    Assigned To
                  </label>
                  <div className="relative">
                    <MultiSelectDropdown
                      options={filterOptions.assigned}
                      selectedValues={filters.assigned}
                      onChange={(values) =>
                        handleFilterChange("assigned", values)
                      }
                      showSearch={true}
                      placeholder="All Administrators"
                    />
                  </div>
                  <SelectedValuesDisplay
                    selectedValues={filters.assigned}
                    options={filterOptions.assigned}
                    onRemove={(value) =>
                      handleRemoveFilterValue("assigned", value)
                    }
                    label="Selected Administrators"
                  />
                </div>

                {/* Content Writer */}
                <div className="space-y-2 relative" style={{ zIndex: 45 }}>
                  <label className="flex items-center text-sm font-medium text-gray-700">
                    <User size={14} className="mr-2 text-blue-500" />
                    Content Writer
                  </label>
                  <MultiSelectDropdown
                    options={filterOptions.contentWriter}
                    selectedValues={filters.contentWriter}
                    onChange={(values) =>
                      handleFilterChange("contentWriter", values)
                    }
                    showSearch={true}
                    placeholder="All Content Writers"
                  />
                  <SelectedValuesDisplay
                    selectedValues={filters.contentWriter}
                    options={filterOptions.contentWriter}
                    onRemove={(value) =>
                      handleRemoveFilterValue("contentWriter", value)
                    }
                    label="Selected Content Writers"
                  />
                </div>

                {/* Application Manager */}
                <div className="space-y-2 relative" style={{ zIndex: 44 }}>
                  <label className="flex items-center text-sm font-medium text-gray-700">
                    <UserCheck size={14} className="mr-2 text-blue-500" />
                    Application Manager
                  </label>
                  <MultiSelectDropdown
                    options={filterOptions.applicationManager}
                    selectedValues={filters.applicationManager}
                    onChange={(values) =>
                      handleFilterChange("applicationManager", values)
                    }
                    placeholder="All Application Managers"
                  />
                  <SelectedValuesDisplay
                    selectedValues={filters.applicationManager}
                    options={filterOptions.applicationManager}
                    onRemove={(value) =>
                      handleRemoveFilterValue("applicationManager", value)
                    }
                    label="Selected Application Managers"
                  />
                </div>

                {/* Visa Manager */}
                <div className="space-y-2 relative" style={{ zIndex: 43 }}>
                  <label className="flex items-center text-sm font-medium text-gray-700">
                    <User size={14} className="mr-2 text-blue-500" />
                    Visa Manager
                  </label>
                  <MultiSelectDropdown
                    options={filterOptions.visaManager}
                    selectedValues={filters.visaManager}
                    onChange={(values) =>
                      handleFilterChange("visaManager", values)
                    }
                    placeholder="All Visa Managers"
                  />
                  <SelectedValuesDisplay
                    selectedValues={filters.visaManager}
                    options={filterOptions.visaManager}
                    onRemove={(value) =>
                      handleRemoveFilterValue("visaManager", value)
                    }
                    label="Selected Visa Managers"
                  />
                </div>

                {/* Loan Manager */}
                <div className="space-y-2 relative" style={{ zIndex: 42 }}>
                  <label className="flex items-center text-sm font-medium text-gray-700">
                    <User size={14} className="mr-2 text-blue-500" />
                    Loan Manager
                  </label>
                  <MultiSelectDropdown
                    options={filterOptions.loanManager}
                    selectedValues={filters.loanManager}
                    onChange={(values) =>
                      handleFilterChange("loanManager", values)
                    }
                    placeholder="All Loan Managers"
                  />
                  <SelectedValuesDisplay
                    selectedValues={filters.loanManager}
                    options={filterOptions.loanManager}
                    onRemove={(value) =>
                      handleRemoveFilterValue("loanManager", value)
                    }
                    label="Selected Loan Managers"
                  />
                </div>

                {/* Branch Filter */}
                <div className="space-y-2 relative" style={{ zIndex: 44 }}>
                  <label className="flex items-center text-sm font-medium text-gray-700">
                    <Building size={14} className="mr-2 text-blue-500" />
                    Branch
                  </label>
                  <div className="relative">
                    <MultiSelectDropdown
                      options={filterOptions.branch}
                      selectedValues={filters.branch}
                      onChange={(values) =>
                        handleFilterChange("branch", values)
                      }
                      placeholder="All Branches"
                    />
                  </div>
                  <SelectedValuesDisplay
                    selectedValues={filters.branch}
                    options={filterOptions.branch}
                    onRemove={(value) =>
                      handleRemoveFilterValue("branch", value)
                    }
                    label="Selected Branches"
                  />
                </div>

                {/* Service Type Filter */}
                <div className="space-y-2 relative" style={{ zIndex: 43 }}>
                  <label className="flex items-center text-sm font-medium text-gray-700">
                    <MapPin size={14} className="mr-2 text-blue-500" />
                    Service Type
                  </label>
                  <div className="relative">
                    <MultiSelectDropdown
                      options={filterOptions.serviceType}
                      selectedValues={filters.serviceType}
                      onChange={(values) =>
                        handleFilterChange("serviceType", values)
                      }
                      placeholder="All Services"
                    />
                  </div>
                  <SelectedValuesDisplay
                    selectedValues={filters.serviceType}
                    options={filterOptions.serviceType}
                    onRemove={(value) =>
                      handleRemoveFilterValue("serviceType", value)
                    }
                    label="Selected Services"
                  />
                </div>

                {/* Country Filter */}
                <div className="space-y-2 relative" style={{ zIndex: 42 }}>
                  <label className="flex items-center text-sm font-medium text-gray-700">
                    <Flag size={14} className="mr-2 text-blue-500" />
                    Country
                  </label>
                  <div className="relative">
                    <MultiSelectDropdown
                      options={filterOptions.country}
                      selectedValues={filters.country}
                      onChange={(values) =>
                        handleFilterChange("country", values)
                      }
                      placeholder="All Countries"
                    />
                  </div>
                  <SelectedValuesDisplay
                    selectedValues={filters.country}
                    options={filterOptions.country}
                    onRemove={(value) =>
                      handleRemoveFilterValue("country", value)
                    }
                    label="Selected Countries"
                  />
                </div>

                {/* Second Row - Lower z-index but still high enough */}
                {/* Intended Degree Filter */}
                <div className="space-y-2 relative" style={{ zIndex: 41 }}>
                  <label className="flex items-center text-sm font-medium text-gray-700">
                    <GraduationCap size={14} className="mr-2 text-blue-500" />
                    Intended Degree
                  </label>
                  <div className="relative">
                    <MultiSelectDropdown
                      options={filterOptions.intendedDegree}
                      selectedValues={filters.intendedDegree}
                      onChange={(values) =>
                        handleFilterChange("intendedDegree", values)
                      }
                      placeholder="All Degrees"
                    />
                  </div>
                  <SelectedValuesDisplay
                    selectedValues={filters.intendedDegree}
                    options={filterOptions.intendedDegree}
                    onRemove={(value) =>
                      handleRemoveFilterValue("intendedDegree", value)
                    }
                    label="Selected Degrees"
                  />
                </div>

                {/* Intake Filter */}
                <div className="space-y-2 relative" style={{ zIndex: 40 }}>
                  <label className="flex items-center text-sm font-medium text-gray-700">
                    <Calendar size={14} className="mr-2 text-blue-500" />
                    Intake
                  </label>
                  <div className="relative">
                    <MultiSelectDropdown
                      options={filterOptions.intake}
                      selectedValues={filters.intake}
                      onChange={(values) =>
                        handleFilterChange("intake", values)
                      }
                      placeholder="All Intakes"
                    />
                  </div>
                  <SelectedValuesDisplay
                    selectedValues={filters.intake}
                    options={filterOptions.intake}
                    onRemove={(value) =>
                      handleRemoveFilterValue("intake", value)
                    }
                    label="Selected Intakes"
                  />
                </div>

                {/* Date Range Filters */}
                <div className="space-y-2 relative" style={{ zIndex: 10 }}>
                  <label className="flex items-center text-sm font-medium text-gray-700">
                    <Calendar size={14} className="mr-2 text-blue-500" />
                    From Date
                  </label>
                  <input
                    type="date"
                    name="fromDate"
                    className="w-full border border-gray-300 rounded-md p-2 text-sm text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    value={filters.fromDate}
                    onChange={handleDateFilterChange}
                  />
                </div>

                <div className="space-y-2 relative" style={{ zIndex: 10 }}>
                  <label className="flex items-center text-sm font-medium text-gray-700">
                    <Calendar size={14} className="mr-2 text-blue-500" />
                    To Date
                  </label>
                  <input
                    type="date"
                    name="toDate"
                    className="w-full border border-gray-300 rounded-md p-2 text-sm text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    value={filters.toDate}
                    onChange={handleDateFilterChange}
                  />
                </div>
              </div>

              {/* Summary of Active Filters */}
              {activeFiltersCount > 0 && (
                <div className="mt-6 pt-4 border-t border-gray-200">
                  <div className="text-sm text-gray-600">
                    <strong>Active Filters Summary:</strong>
                  </div>
                  <div className="mt-2 text-sm text-gray-500">
                    {Object.entries(filters).map(([key, values]) => {
                      if (Array.isArray(values) && values.length > 0) {
                        return (
                          <span key={key} className="mr-4">
                            {key.charAt(0).toUpperCase() + key.slice(1)}:{" "}
                            {values.length} selected
                          </span>
                        );
                      }
                      if (typeof values === "string" && values !== "") {
                        return (
                          <span key={key} className="mr-4">
                            {key.charAt(0).toUpperCase() + key.slice(1)}:{" "}
                            {values}
                          </span>
                        );
                      }
                      return null;
                    })}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Results Section */}
        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
          {/* Table Header with controls */}
          <div className="px-4 sm:px-6 py-4 border-b border-gray-200">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
              <div className="flex items-center gap-3">
                <h2 className="text-base sm:text-lg font-bold text-gray-800">
                  {archived ? "Archived Customers" : "Students"}
                </h2>
                <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                  {filteredBySearch.length} records
                </span>
                {selectedCustomers.length > 0 && (
                  <span className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                    {selectedCustomers.length} selected
                  </span>
                )}
              </div>

              <div className="flex items-center gap-3">
                {/* View Toggle - Mobile/Tablet */}
                <div className="lg:hidden flex bg-gray-100 rounded-lg p-1">
                  <button
                    onClick={() => setViewMode("cards")}
                    className={`px-3 py-1 text-xs font-medium rounded-md transition-colors ${
                      viewMode === "cards"
                        ? "bg-white text-gray-900 shadow-sm"
                        : "text-gray-600"
                    }`}
                  >
                    Cards
                  </button>
                  <button
                    onClick={() => setViewMode("table")}
                    className={`px-3 py-1 text-xs font-medium rounded-md transition-colors ${
                      viewMode === "table"
                        ? "bg-white text-gray-900 shadow-sm"
                        : "text-gray-600"
                    }`}
                  >
                    Table
                  </button>
                </div>

                {/* Per page selector */}
                <div className="flex items-center">
                  <label className="text-sm text-gray-600 mr-2 hidden sm:inline">
                    Per page:
                  </label>
                  <select
                    value={customersPerPage}
                    onChange={(e) => {
                      const value =
                        e.target.value === "all"
                          ? filteredBySearch.length
                          : Number(e.target.value);
                      setCustomersPerPage(value);
                      setCurrentPage(1);
                    }}
                    className="border border-gray-300 rounded-md p-1 text-sm text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value="all">All</option>
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* Loading State */}
          {isLoading ? (
            <div className="p-12 sm:p-20 flex justify-center items-center">
              <div className="animate-spin rounded-full h-8 w-8 sm:h-12 sm:w-12 border-t-2 border-b-2 border-blue-500"></div>
            </div>
          ) : (
            <>
              {/* Desktop Table View */}
              {viewMode === "table" && (
                <div className="hidden lg:block">
                  <div className="overflow-x-auto w-full">
                    <table className="min-w-[1024px] w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="px-6 py-3 text-left">
                            <input
                              type="checkbox"
                              onChange={handleSelectAll}
                              checked={
                                currentCustomers.length > 0 &&
                                selectedCustomers.length ===
                                  currentCustomers.length
                              }
                              className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                            />
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            ID
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Student Name
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Email ID
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            <div
                              className="flex items-center cursor-pointer hover:text-gray-700"
                              onClick={() => {
                                setSortBy("created_at");
                                setSortOrder(
                                  sortOrder === "asc" ? "desc" : "asc"
                                );
                              }}
                            >
                              <span>Date Created</span>
                              {sortBy === "created_at" && (
                                <span className="ml-1">
                                  {sortOrder === "asc" ? "▲" : "▼"}
                                </span>
                              )}
                            </div>
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Intake
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Service Taken
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Branch
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {currentCustomers.length > 0 ? (
                          currentCustomers.map((customer, index) => (
                            <tr
                              key={customer.id}
                              className="hover:bg-gray-50 transition-colors"
                            >
                              <td className="px-6 py-4 whitespace-nowrap">
                                <input
                                  type="checkbox"
                                  checked={selectedCustomers.includes(
                                    customer.id
                                  )}
                                  onChange={(e) => handleSelect(customer.id, e)}
                                  className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                                />
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm text-gray-900">
                                  {indexOfFirstCustomer + index + 1}
                                </div>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex items-center">
                                  <div className="flex-shrink-0 h-10 w-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-800 font-medium">
                                    {customer.name.charAt(0).toUpperCase()}
                                  </div>
                                  <div className="ml-4">
                                    <div className="text-sm font-medium text-gray-900">
                                      {customer.name}
                                    </div>
                                    <div className="text-sm text-gray-500">
                                      {capitalizeName(
                                        getAssignedName(customer.assigned_to)
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm text-gray-900">
                                  {customer.email}
                                </div>
                                <div className="text-xs text-gray-500">
                                  {customer.phone || "No phone"}
                                </div>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                {formatDateTime(customer.created_at) || "-"}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                {customer.intake || "-"}
                              </td>
                              <td className="px-6 py-4">
                                <div className="text-sm text-gray-900">
                                  {formatServices(customer.services)}
                                </div>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                {customer.branch ? (
                                  <span className="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                                    {customer.branch}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                <div className="flex items-center gap-2">
                                  <button
                                    onClick={() => handleRowClick(customer.id)}
                                    className="text-blue-600 hover:text-blue-900 bg-blue-50 hover:bg-blue-100 px-3 py-1 rounded-md transition-colors flex items-center"
                                  >
                                    <Eye size={16} className="mr-1" />
                                    View
                                  </button>
                                  <button
                                    onClick={(e) =>
                                      handleArchiveToggle(
                                        customer.id,
                                        !archived,
                                        e
                                      )
                                    }
                                    className={`px-3 py-1 rounded-md transition-colors text-white ${
                                      archived
                                        ? "bg-emerald-600 hover:bg-emerald-700"
                                        : "bg-amber-600 hover:bg-amber-700"
                                    }`}
                                  >
                                    {archived ? "Unarchive" : "Archive"}
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan="9"
                              className="px-6 py-12 text-center text-gray-500"
                            >
                              <div className="flex flex-col items-center">
                                <Search className="h-12 w-12 text-gray-300 mb-3" />
                                <p className="text-lg font-medium mb-1">
                                  No students found
                                </p>
                                <p className="text-sm">
                                  Try adjusting your filters or search terms
                                </p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* Mobile/Tablet Table View */}
              {viewMode === "table" && (
                <div className="lg:hidden block overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-3 py-3 text-left">
                          <input
                            type="checkbox"
                            onChange={handleSelectAll}
                            checked={
                              currentCustomers.length > 0 &&
                              selectedCustomers.length ===
                                currentCustomers.length
                            }
                            className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                          />
                        </th>
                        <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Student
                        </th>
                        <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Details
                        </th>
                        <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {currentCustomers.length > 0 ? (
                        currentCustomers.map((customer, index) => (
                          <tr
                            key={customer.id}
                            className="hover:bg-gray-50 transition-colors"
                          >
                            <td className="px-3 py-4 whitespace-nowrap">
                              <input
                                type="checkbox"
                                checked={selectedCustomers.includes(
                                  customer.id
                                )}
                                onChange={(e) => handleSelect(customer.id, e)}
                                className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                              />
                            </td>
                            <td className="px-3 py-4">
                              <div className="flex items-center">
                                <div className="flex-shrink-0 h-8 w-8 bg-blue-100 rounded-full flex items-center justify-center text-blue-800 font-medium text-sm">
                                  {customer.name.charAt(0).toUpperCase()}
                                </div>
                                <div className="ml-3">
                                  <div className="text-sm font-medium text-gray-900">
                                    {customer.name}
                                  </div>
                                  <div className="text-xs text-gray-500">
                                    {customer.email}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="px-3 py-4">
                              <div className="text-xs text-gray-500 space-y-1">
                                <div>
                                  <span className="font-medium">Created:</span>{" "}
                                  {formatDateTime(customer.created_at) || "-"}
                                </div>
                                <div>
                                  <span className="font-medium">Intake:</span>{" "}
                                  {customer.intake || "-"}
                                </div>
                                <div>
                                  <span className="font-medium">Branch:</span>{" "}
                                  {customer.branch ? (
                                    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                                      {customer.branch}
                                    </span>
                                  ) : (
                                    "-"
                                  )}
                                </div>
                              </div>
                            </td>
                            <td className="px-3 py-4 whitespace-nowrap">
                              <div className="flex flex-col gap-2">
                                <button
                                  onClick={() => handleRowClick(customer.id)}
                                  className="text-blue-600 hover:text-blue-900 bg-blue-50 hover:bg-blue-100 px-2 py-1 rounded-md transition-colors flex items-center text-xs"
                                >
                                  <Eye size={14} className="mr-1" />
                                  View
                                </button>
                                <button
                                  onClick={(e) =>
                                    handleArchiveToggle(
                                      customer.id,
                                      !archived,
                                      e
                                    )
                                  }
                                  className={`px-2 py-1 rounded-md transition-colors text-xs text-white ${
                                    archived
                                      ? "bg-emerald-600 hover:bg-emerald-700"
                                      : "bg-amber-600 hover:bg-amber-700"
                                  }`}
                                >
                                  {archived ? "Unarchive" : "Archive"}
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="4"
                            className="px-6 py-12 text-center text-gray-500"
                          >
                            <div className="flex flex-col items-center">
                              <Search className="h-8 w-8 text-gray-300 mb-2" />
                              <p className="text-sm font-medium mb-1">
                                No students found
                              </p>
                              <p className="text-xs">
                                Try adjusting your filters or search terms
                              </p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}

              {/* Mobile Card View */}
              <div
                className="lg:hidden"
                style={{ display: viewMode === "cards" ? "block" : "none" }}
              >
                {currentCustomers.length > 0 ? (
                  <div className="p-4 space-y-4">
                    {currentCustomers.map((customer, index) => (
                      <div
                        key={customer.id}
                        className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow"
                      >
                        <div className="flex items-start justify-between mb-3">
                          <div className="flex items-center">
                            <input
                              type="checkbox"
                              checked={selectedCustomers.includes(customer.id)}
                              onChange={(e) => handleSelect(customer.id, e)}
                              className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500 mr-3"
                            />
                            <div className="flex-shrink-0 h-10 w-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-800 font-medium">
                              {customer.name.charAt(0).toUpperCase()}
                            </div>
                            <div className="ml-3">
                              <div className="text-sm font-semibold text-gray-900">
                                {customer.name}
                              </div>
                              <div className="text-xs text-gray-500">
                                ID: {indexOfFirstCustomer + index + 1}
                              </div>
                            </div>
                          </div>
                          <div className="flex flex-col gap-2">
                            <button
                              onClick={() => handleRowClick(customer.id)}
                              className="text-blue-600 hover:text-blue-900 bg-blue-50 hover:bg-blue-100 px-3 py-1 rounded-md transition-colors flex items-center text-sm"
                            >
                              <Eye size={14} className="mr-1" />
                              View
                            </button>
                            <button
                              onClick={(e) =>
                                handleArchiveToggle(customer.id, !archived, e)
                              }
                              className={`px-3 py-1 rounded-md transition-colors text-sm text-white ${
                                archived
                                  ? "bg-emerald-600 hover:bg-emerald-700"
                                  : "bg-amber-600 hover:bg-amber-700"
                              }`}
                            >
                              {archived ? "Unarchive" : "Archive"}
                            </button>
                          </div>
                        </div>

                        <div className="grid grid-cols-2 gap-3 text-xs">
                          <div>
                            <span className="font-medium text-gray-700">
                              Email:
                            </span>
                            <div className="text-gray-600 truncate">
                              {customer.email}
                            </div>
                          </div>
                          <div>
                            <span className="font-medium text-gray-700">
                              Phone:
                            </span>
                            <div className="text-gray-600">
                              {customer.phone || "N/A"}
                            </div>
                          </div>
                          <div>
                            <span className="font-medium text-gray-700">
                              Created:
                            </span>
                            <div className="text-gray-600">
                              {formatDateTime(customer.created_at) || "-"}
                            </div>
                          </div>
                          <div>
                            <span className="font-medium text-gray-700">
                              Intake:
                            </span>
                            <div className="text-gray-600">
                              {customer.intake || "-"}
                            </div>
                          </div>
                          <div>
                            <span className="font-medium text-gray-700">
                              Branch:
                            </span>
                            <div className="text-gray-600">
                              {customer.branch ? (
                                <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                                  {customer.branch}
                                </span>
                              ) : (
                                "-"
                              )}
                            </div>
                          </div>
                          <div>
                            <span className="font-medium text-gray-700">
                              Assigned:
                            </span>
                            <div className="text-gray-600">
                              {getAssignedName(customer.assigned_to)}
                            </div>
                          </div>
                        </div>

                        <div className="mt-3 pt-3 border-t border-gray-100">
                          <span className="font-medium text-gray-700 text-xs">
                            Services:
                          </span>
                          <div className="text-gray-600 text-xs mt-1">
                            {formatServices(customer.services)}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="p-12 text-center text-gray-500">
                    <div className="flex flex-col items-center">
                      <Search className="h-12 w-12 text-gray-300 mb-3" />
                      <p className="text-lg font-medium mb-1">
                        No students found
                      </p>
                      <p className="text-sm">
                        Try adjusting your filters or search terms
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {/* Pagination */}
              {filteredBySearch.length > 0 && (
                <div className="bg-gray-50 px-4 sm:px-6 py-4 border-t border-gray-200">
                  <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                    {/* Results info */}
                    <div className="text-sm text-gray-700 text-center sm:text-left">
                      Showing{" "}
                      <span className="font-medium">
                        {indexOfFirstCustomer + 1}
                      </span>{" "}
                      to{" "}
                      <span className="font-medium">
                        {Math.min(indexOfLastCustomer, filteredBySearch.length)}
                      </span>{" "}
                      of{" "}
                      <span className="font-medium">
                        {filteredBySearch.length}
                      </span>{" "}
                      students
                    </div>

                    {/* Pagination controls */}
                    <div className="flex items-center">
                      <nav
                        className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
                        aria-label="Pagination"
                      >
                        {/* First page button */}
                        <button
                          onClick={() => paginate(1)}
                          disabled={currentPage === 1}
                          className={`relative inline-flex items-center px-2 py-2 rounded-l-md border text-sm font-medium ${
                            currentPage === 1
                              ? "bg-gray-100 border-gray-300 text-gray-400 cursor-not-allowed"
                              : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50"
                          }`}
                        >
                          <span className="sr-only">First</span>
                          <ChevronsLeft className="h-4 w-4" />
                        </button>

                        {/* Previous page button */}
                        <button
                          onClick={() => paginate(currentPage - 1)}
                          disabled={currentPage === 1}
                          className={`relative inline-flex items-center px-2 py-2 border text-sm font-medium ${
                            currentPage === 1
                              ? "bg-gray-100 border-gray-300 text-gray-400 cursor-not-allowed"
                              : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50"
                          }`}
                        >
                          <span className="sr-only">Previous</span>
                          <ChevronLeft className="h-4 w-4" />
                        </button>

                        {/* Page number buttons */}
                        {[
                          ...Array(
                            Math.min(
                              typeof window !== "undefined" &&
                                window.innerWidth < 640
                                ? 3
                                : 5,
                              totalPages
                            )
                          ),
                        ].map((_, i) => {
                          let pageNum;
                          const maxPages =
                            typeof window !== "undefined" &&
                            window.innerWidth < 640
                              ? 3
                              : 5;

                          if (totalPages <= maxPages) {
                            pageNum = i + 1;
                          } else if (
                            currentPage <=
                            Math.floor(maxPages / 2) + 1
                          ) {
                            pageNum = i + 1;
                          } else if (
                            currentPage >=
                            totalPages - Math.floor(maxPages / 2)
                          ) {
                            pageNum = totalPages - maxPages + 1 + i;
                          } else {
                            pageNum =
                              currentPage - Math.floor(maxPages / 2) + i;
                          }

                          if (pageNum > totalPages) return null;

                          return (
                            <button
                              key={pageNum}
                              onClick={() => paginate(pageNum)}
                              className={`relative inline-flex items-center px-3 sm:px-4 py-2 border text-sm font-medium ${
                                currentPage === pageNum
                                  ? "z-10 bg-blue-50 border-blue-500 text-blue-600"
                                  : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50"
                              }`}
                            >
                              {pageNum}
                            </button>
                          );
                        })}

                        {/* Next page button */}
                        <button
                          onClick={() => paginate(currentPage + 1)}
                          disabled={currentPage === totalPages}
                          className={`relative inline-flex items-center px-2 py-2 border text-sm font-medium ${
                            currentPage === totalPages
                              ? "bg-gray-100 border-gray-300 text-gray-400 cursor-not-allowed"
                              : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50"
                          }`}
                        >
                          <span className="sr-only">Next</span>
                          <ChevronRight className="h-4 w-4" />
                        </button>

                        {/* Last page button */}
                        <button
                          onClick={() => paginate(totalPages)}
                          disabled={currentPage === totalPages}
                          className={`relative inline-flex items-center px-2 py-2 rounded-r-md border text-sm font-medium ${
                            currentPage === totalPages
                              ? "bg-gray-100 border-gray-300 text-gray-400 cursor-not-allowed"
                              : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50"
                          }`}
                        >
                          <span className="sr-only">Last</span>
                          <ChevronsRight className="h-4 w-4" />
                        </button>
                      </nav>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerList;
